<template>
  <header class="site-header">
    <div class="header-shell">
      <div class="banner-row">
        <div class="banner-spacer" aria-hidden="true"></div>
        <div class="banner-wrap">
          <img class="banner" src="/banner.png" alt="Banner" />
        </div>
        <div class="banner-spacer" aria-hidden="true"></div>
      </div>

      <div class="header-container sticky-nav">
        <nav>
          <router-link to="/">Kodu</router-link>
          <!--<router-link to="/rehvid">Rehvid</router-link>-->
          <!--<router-link to="/auto24">Auto24</router-link>-->
          <a href="https://www.auto24.ee/api/mlrehvid/parts/?cid=64">Rehvid</a>
          <a href="https://www.auto24.ee/api/mlrehvid/parts/?cid=62">Veljed</a>
          <router-link to="/hinnakiri">Hinnakiri</router-link>
          <router-link to="/contactus">Meist</router-link>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
.site-header {
  position: relative;
  z-index: 20;
  padding: 18px 0 16px 0;
  background:
    radial-gradient(circle at 15% 10%, rgba(226, 34, 137, 0.24), transparent 30%),
    radial-gradient(circle at 86% 0%, rgba(255, 137, 195, 0.16), transparent 26%),
    linear-gradient(135deg, #151217 0%, #241a22 55%, #111013 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-shell {
  width: min(100% - 36px, 1180px);
  margin: 0 auto;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.055);
  box-shadow: 0 26px 70px rgba(0, 0, 0, 0.26);
}

.banner-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
}

.banner-wrap {
  margin: 0;
  flex: 1;
  padding: 6px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.22);
  overflow: hidden;
}

.banner {
  display: block;
  width: 100%;
  height: clamp(118px, 13vw, 176px);
  object-fit: contain;
  object-position: center;
  border-radius: 6px;
}

.banner-spacer {
  display: none;
}

@media (max-width: 768px) {
  .banner-row {
    width: 100%;
  }

  .banner-wrap {
    padding: 4px;
  }

  .banner {
    height: clamp(72px, 22vw, 96px);
    object-fit: contain;
    object-position: center;
  }
}

.header-container {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
  margin: 10px auto 0 auto;
  padding: 7px;
  background: rgba(20, 17, 20, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  box-sizing: border-box;
  backdrop-filter: blur(14px);
}

.sticky-nav {
  position: sticky;
  top: 8px;
  z-index: 1000;
}

nav {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

nav a {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  color: rgba(255, 247, 251, 0.92);
  text-decoration: none;
  font-weight: 700;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 7px;
  transition: background-color 0.25s ease, color 0.25s ease,
    border-color 0.25s ease;
  white-space: nowrap;
}

nav a:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 137, 195, 0.55);
  color: #ffffff;
}

nav a:active {
  background-color: rgba(255, 137, 195, 0.2);
}

nav a:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 137, 195, 0.32);
}

/* Active route styling */
nav a.router-link-exact-active {
  background-color: #e22289;
  color: #fff;
  border-color: #e22289;
  box-shadow: 0 8px 18px rgba(226, 34, 137, 0.26);
}

@media (max-width: 768px) {
  .site-header {
    padding: 10px 0;
  }

  .header-shell {
    width: calc(100% - 20px);
    max-width: calc(100vw - 20px);
    padding: 7px;
  }

  .header-container {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    padding: 6px;
    margin-top: 8px;
  }

  nav {
    width: calc(100vw - 48px);
    max-width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 6px;
  }

  nav a {
    min-width: 0;
    padding: 0 8px;
    min-height: 38px;
    font-size: 0.88rem;
  }
}

@media (max-width: 560px) {
  .header-shell {
    width: calc(100% - 20px);
    max-width: 370px;
    margin-left: 10px;
    margin-right: auto;
  }

  nav {
    width: 100%;
  }

  nav {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  nav a {
    font-size: 0.92rem;
  }

  nav a:last-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 380px) {
  nav a {
    font-size: 0.88rem;
    padding: 0 8px;
  }
}
</style>
